import { createReducer } from "@reduxjs/toolkit";
import {
  createManualVerification,
  createManualVerificationSuccess,
  createManualVerificationFailure,
} from "./actions";

const initialState = {
  isLoading: false,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(createManualVerification.type, (state) => ({
      ...state,
      isLoading: true,
    }))
    .addCase(createManualVerificationSuccess.type, (state) => ({
      ...state,
      isLoading: false,
    }))
    .addCase(createManualVerificationFailure.type, (state) => ({
      ...state,
      isLoading: false,
    }));
});
